<script lang="ts">
  import { onMount } from 'svelte';
  import { GoogleIcon, RatingStar } from '../../components/icons';
  import Swiper from 'swiper';
  import { Pagination, Navigation } from 'swiper/modules';
  import 'swiper/css';
  import 'swiper/css/pagination';
  import 'swiper/css/navigation';
  import type { Testimonial } from '../types';

  export let items: Testimonial['items'];

  let element: HTMLDivElement;
  let uniqueId = Math.random().toString(36).substring(2, 15);

  onMount(() => {
    const totalTestimonials = items.length;
    let totalSlider;
    if (totalTestimonials > 3) {
      totalSlider = 3.7;
    } else if (totalTestimonials === 3) {
      totalSlider = 1.9;
    } else {
      totalSlider = 1;
    }

    new Swiper(element, {
      modules: [Pagination, Navigation],
      direction: 'horizontal',
      loop: true,
      slidesPerView: 1.1,
      centeredSlides: true,
      spaceBetween: 10,
      breakpoints: {
        600: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        1024: {
          slidesPerView: totalSlider,
          spaceBetween: 20,
        },
      },
      // If we need pagination
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      navigation: {
        nextEl: `#swiper-button-next-${uniqueId}`,
        prevEl: `#swiper-button-prev-${uniqueId}`,
      },
    });
  });
</script>

<div class="container">
  <div class="swiper sample-slider" bind:this={element}>
    <div class="testimonial-holder swiper-wrapper">
      {#each items as { description, location, profilePicture, rating, title }}
        {#if title?.value && description?.value && location?.value && profilePicture?.image?.url && rating?.value}
          <div class="testimonial swiper-slide">
            <div class="testimonial-top">
              <div class="image">
                <img
                  loading="lazy"
                  src={profilePicture?.image?.url}
                  alt="img-review"
                />
              </div>
              <div>
                <p class="text">{@html title?.value}</p>
                <p class="text">{@html location?.value}</p>
              </div>
              <div class="google-icon">
                <GoogleIcon />
              </div>
            </div>
            <div class="stars">
              {#each Array.from(Array(Math.floor(rating.value)).keys()) as _}
                <RatingStar />
              {/each}
            </div>
            <div>
              <p class="text">
                {@html description?.value}
              </p>
            </div>
          </div>
        {/if}
      {/each}
    </div>

    <div class="swiper-pagination" />
  </div>
</div>

<div class="swiper-button-prev" id="swiper-button-prev-{uniqueId}">
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
  >
    <path
      d="M13.2069 17.293L8.91394 13H18.4999V11H8.91394L13.2069 6.70697L11.7929 5.29297L5.08594 12L11.7929 18.707L13.2069 17.293Z"
      fill="#111111"
      fill-opacity="0.64"
    />
  </svg>
</div>
<div class="swiper-button-next" id="swiper-button-next-{uniqueId}">
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
  >
    <path
      d="M11.793 17.293L13.207 18.707L19.914 12L13.207 5.29297L11.793 6.70697L16.086 11H6.5V13H16.086L11.793 17.293Z"
      fill="#111111"
      fill-opacity="0.64"
    />
  </svg>
</div>
